import React, {useState, useRef, useEffect} from 'react';
import ListFactory from 'factories/AccountLists';
import ListService from 'services/AccountLists/';
import PubSub from 'services/PubSub/';
import LoginService from "services/Login/";
import Modal from 'components/Modal';
import ProductListItem from './ProductListItem';
import Loader from "components/Loader";
import { actionsType } from 'config/constants';
import style from './style.scss'; //NOSONAR
import TagManagerService from 'services/TagManager';

let actions = [];
let lists = [];
let listCurrent = [];
let multiSku = [];
let config = {};

let currentSku = null;
const ModalAddToList = () => {
    const inputName = useRef();

    const [loading, setLoading] = useState(true);
    const [loadingBtnSave, setLoadingBtnSave] = useState(false);
    const [loadingBtnCreate, setLoadingBtnCreate] = useState(false);
    const [buttomSaved, setButtomSaved] = useState(false);
    const [enabledButton, setEnabledButton] = useState(false);
    const [enabledButtonCreate, setEnabledButtonCreate] = useState(false);
    const [headerCheckout, setHeaderCheckout] = useState(false);
    

    let name = '';
    
    useEffect(() => {
        actions.push(PubSub.register(actionsType.MODAL.ADD_TO_LIST_OPEN, _openModalModalAddToList));

        actions.push(PubSub.register('modal_quantity_value', changeQuantity));

        return function cleanup() {
            actions = actions.map(token => PubSub.unregister(token));
            actions = [];
            lists = [];
            listCurrent = [];
        };
    }, [])

    const _openModalModalAddToList = (payload) => {
        if (LoginService.isLogged()) {
            setHeaderCheckout(payload.value.headerCheckout);
            if (payload.value.orderItems) {
                multiSku = payload.value.orderItems;
                
            }

            if (!multiSku.length) {
                currentSku = payload.value.skuId;
                config = payload.value.config;
            }
            lists = [];
            listCurrent = [];
            _getLists();
            setEnabledButton(false);
            setEnabledButtonCreate(false);
            setLoading(true);
            setButtomSaved(false);
        } else {
            setTimeout(() => {
                _closeModalModalAddToList();
                PubSub.dispatch('login_open', {
                    successCallback: () => {

                        setTimeout(() => {
                            PubSub.dispatch(actionsType.MODAL.ADD_TO_LIST_OPEN, { skuId: currentSku, orderItems: multiSku, config: config });
                        }, 1);

                        if (payload.value.orderItems) {
                            multiSku = payload.value.orderItems;
                        }

                        if (!multiSku.length) {
                            currentSku = payload.value.skuId;
                            config = payload.value.config;
                        }
                        lists = [];
                        listCurrent = [];
                        _getLists();
                        setEnabledButton(false);
                        setEnabledButtonCreate(false);
                        setLoading(true);
                        
                    }
                });
            }, 0);
        }
    }

    const _closeModalModalAddToList = () => {
        setTimeout(()=> PubSub.dispatch(actionsType.MODAL.ADD_TO_LIST_CLOSE), 0);
    }

    const _getLists = () => {
        setLoading(true);

        ListService.getAll().then(data => {

            lists = data.map((list) => ListFactory.create(list));

            if (lists.length == 0) {
                _closeModalModalAddToList();
                PubSub.dispatch('create_new_list_open', {
                    title: 'Aún no tienes listas registradas, nombra y crea tu lista a continuación',
                    setting: {
                        callback: () => {
                            setTimeout(() => {
                                PubSub.dispatch('add_to_list_open', { skuId: currentSku, orderItems: multiSku, config: config });
                            }, 1);
                        }
                    },
                })
            }

            for (let i = 0; i < lists.length; i++) {
                if (lists[i].skus)
                    for (var key in lists[i].skus) {
                        var obj = lists[i].skus[key];
                        if (currentSku === key) {
                            listCurrent.push({
                                name: lists[i].name,
                                quantity: obj.quantity,
                                id: lists[i].id,
                                stateCheck: true
                            });
                            lists[i].quantity = obj.quantity;
                        }
                    }
            }

            setLoading(false);
        });
    }

    const changeQuantity = (payload) => {
        const item = payload.value;
        setEnabledButton(true);

        if (item.stateCheck) {

            var index = listCurrent.findIndex(i => i.id == item.id);
            if (index != -1) {
                listCurrent[index].quantity = item.quantity;
            } else {
                listCurrent.push(item);
            }

        } else {

            listCurrent[listCurrent.findIndex(i => i.id == item.id)].stateCheck = false;
            listCurrent[listCurrent.findIndex(i => i.id == item.id)].quantity = 0;
        }
    }

    const _createList = () => {
        if (inputName.current.value) {

            setLoadingBtnCreate(true);

            ListService.createEmptyList(inputName.current.value).then(result => {
                if (result && result.Id) {
                    inputName.current.value = '';
                    _getLists();
                    name = "";
                    setEnabledButtonCreate(false);
                }

                setLoadingBtnCreate(false);
            });
        }
    }

    const _saveChangesList = () => {
        if (multiSku.length == 0)
            _saveCurrentSku();
        else
            _saveMultiSku();
    }

    const _saveCurrentSku = () => {
        if (enabledButton) {
            const cSku = currentSku;
            setLoadingBtnSave(true);

            let listTagManager = [];

            for (let i = 0; i < listCurrent.length; i++) {
                var index = lists.findIndex(val => val.id == listCurrent[i].id);

                if (index !== -1) {
                    if (lists[index].skus && Object.keys(lists[index].skus).length) {

                        if (listCurrent[i].quantity == 0) {
                            delete lists[index].skus[cSku];
                        } else if (lists[index].skus[cSku]) {
                            lists[index].skus[cSku].quantity = listCurrent[i].quantity;
                            listTagManager.push(lists[index].name);
                        } else {
                            lists[index].skus[cSku] = { quantity: listCurrent[i].quantity };
                            listTagManager.push(lists[index].name);
                        }
                    } else {

                        lists[index].skus = { [cSku]: { quantity: listCurrent[i].quantity } };
                        listTagManager.push(lists[index].name);
                    }
                }

                ListService.updateList(lists[index]).then(() => {
                    setLoadingBtnSave(false);
                    setButtomSaved(true);

                    setTimeout(() => {
                        _closeModalModalAddToList();
                        PubSub.dispatch('list_update');
                    }, 1000);

                })
            }
            if(listTagManager.length){
                TagManagerService.addList('Agregar producto', listTagManager.toString());
            }
        }
    }

    const _saveMultiSku = () => {
        if (enabledButton) {
            setLoadingBtnSave(true);
            let listTagManager = [];
            for (let i = 0; i < listCurrent.length; i++) {
                var index = lists.findIndex(val => val.id == listCurrent[i].id);
                for (let j = 0; j < Object.keys(multiSku).length; j++) {
                    let cSku = Object.keys(multiSku)[j];
                    if (index != -1) {
                        if (lists[index].skus && Object.keys(lists[index].skus).length) {

                            if (lists[index].skus[cSku]) {
                                lists[index].skus[cSku].quantity = multiSku[cSku].quantity;
                            } else {
                                lists[index].skus[cSku] = { quantity: multiSku[cSku].quantity };
                            }

                        } else {
                            lists[index].skus = { [cSku]: { quantity: multiSku[cSku].quantity } };
                        }
                        if(listTagManager.indexOf(lists[index].name) === -1){
                            listTagManager.push(lists[index].name);
                        }
                    }

                }
                ListService.updateList(lists[index]).then(() => {
                    setLoadingBtnSave(false);
                    setButtomSaved(true);

                    setTimeout(() => {
                        _closeModalModalAddToList();
                        PubSub.dispatch('list_update');
                    }, 1000);

                });

            }
            TagManagerService.saveList('Save from Cart', listTagManager.toString());
        }
    }

    const _changeTextInput = (event) => {
        name = event.target.value;

        if (name) {
            setEnabledButtonCreate(true);
        } else {
            setEnabledButtonCreate(false);
        }
    }

    return (
        <Modal customClass={'modal-add-to-list' + (headerCheckout ? ' header-checkout' : '')} actionOpen={actionsType.MODAL.ADD_TO_LIST_OPEN} actionClose={actionsType.MODAL.ADD_TO_LIST_CLOSE}>
            <div className={'new-modal-container'}>
                <div className={'new-modal-scroll'}>
                    <div className="wrap-add-to-list">
                        <div className='new-modal-title'>
                            Agregar a una lista
                        </div>
                        <div className='modal-add-to-list-subtitle'>
                            Selecciona una lista para agregar tus productos
                        </div>
                        <div className="modal-add-to-list-container-list-buy" >
                            {loading && <div className="modal-add-to-list-loader"> <Loader /> </div>}
                            {!loading && (lists == 0) && <span className='no-lists'>Todavía no tienes listas creadas.</span>}
                            {lists && lists.map((list) =>
                                <ProductListItem item={list} key={list.id} config={config} />
                            )}
                        </div>
                        <div className='modal-add-to-list-subtitle'>
                            O puedes agregarlos a una lista nueva
                        </div>
                        <div className="modal-add-to-list-container-new-list">
                            <input type="text" className="modal-add-to-list-input" placeholder="Nombre de nueva lista" maxLength="50" ref={inputName} onChange={(event) => _changeTextInput(event)} />
                            {!loadingBtnCreate && <button className={enabledButtonCreate ? 'secundary-btn modal-add-to-list-create-btn' : ' disabled-btn modal-add-to-list-create-btn-disabled'} onClick={() => _createList()}> Crear </button>}
                            {loadingBtnCreate && <button className={'modal-buttom-loader-create-list'}>
                                <Loader />
                            </button>}
                        </div>
                    </div>
                    
                </div>
            
                <div className={'modal-actions'}>
                    {!loadingBtnSave && !buttomSaved && <button className={enabledButton ? ' primary-btn modal-add-to-list-btn-save-active ' : ' disabled-btn modal-add-to-list-btn-save-disabled '} onClick={() => _saveChangesList()} >
                        <span>Guardar</span>
                    </button>}
                    {loadingBtnSave && <button className={'product-add-to-cart'}>
                        <Loader />
                    </button>}
                    {buttomSaved && <button className={' primary-btn modal-add-to-list-btn-save-active '} >
                        <span className="font-icn check"></span>
                        <span className="modal-add-to-list-btn-title-save">Guardado</span>
                    </button>}
                </div>
            </div>
        </Modal>
    )
}

export default ModalAddToList;

